import { Button } from "@chakra-ui/button";
import { Heading, Stack } from "@chakra-ui/layout";
import React, { useEffect } from "react";
import { signIn } from "next-auth/client";
import { logout } from "utils/sessionHelper";
import { TweetContext } from "context/tweetContext";

const ProtectedRoute = () => {
  const tweetContext: any = React.useContext(TweetContext);

  const baseUrl =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://app.tweethunter.io";

  useEffect(() => {
    tweetContext.setIsOpen(false);
  }, []);

  return (
    <Stack maxW={400} spacing={4} margin="auto" mt="5vh">
      <Heading fontSize="2xl" textAlign="center">
        You have been logged out.
      </Heading>
      <Heading p={10} fontSize="lg" textAlign="center">
        Please login to continue using the app.
      </Heading>
      <Button
        variant={"primary"}
        onClick={() => {
          logout(false);
          let currentUrl = window?.location?.href;
          if (!currentUrl)
            currentUrl = baseUrl + "/subscribe";
          signIn("twitter", {
            callbackUrl: currentUrl,
          })
        }}
      >
        Sign in
      </Button>
    </Stack>
  );
};

export default ProtectedRoute;
